var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[_c('video-toolbar-edit'),_c('div',{staticClass:"fix-scroll"},[(_vm.videoController.file)?_c('VideoViewer'):_c('p-upload-dropzone',{attrs:{"type":'videovr',"image":require('../background_empty.svg')},on:{"file-uploaded":_vm.uploadFile}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }